import { render, staticRenderFns } from "./editFilmRecord.vue?vue&type=template&id=6c7ed844&scoped=true&"
import script from "./editFilmRecord.vue?vue&type=script&lang=js&"
export * from "./editFilmRecord.vue?vue&type=script&lang=js&"
import style0 from "./editFilmRecord.vue?vue&type=style&index=0&id=6c7ed844&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7ed844",
  null
  
)

export default component.exports